/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { TextInput, TextInputGroup, Button } from '../../../components/Styled';
import Dialog from '../../../components/Dialog';
import iconEyeClose from '../../../assets/icon/icon-eye-close.svg';
import iconEyeOpen from '../../../assets/icon/icon-eye-open.svg';
import Icon from '../../../components/Icon';
import API from '../../../configs/api';
import action from '../../../configs/redux/action';
import type { AppDispatch } from '../../../configs/redux/store';

const WrapperDialogNewPasswordWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: max-content !important;
  padding: 0;
  gap: 0.5rem;
`;

const TextInputStyled = styled(TextInput)`
  width: 100% !important;
  border: 1px solid #8b8b8b !important;
`;

const TextInputGroupStyled = styled(TextInputGroup)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100% !important;
  height: max-content;
  padding: 0;
  margin: 0;
  gap: 0.5rem;
`;

const WrapperTextInput = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  margin: 0 auto;
  gap: 1rem;
`;

const WrapperDialogFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 0;
  margin-top: 1rem;
`;

const ButtonStyled = styled(Button)`
  width: 100% !important;
  background: red;
  color: #ffffff;
  font-weight: 900;

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0.5rem;
  margin: 0;
  gap: 0.5rem;
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  background: red;
  border-radius: 10px;
`;

const isStrongPassword = (password: string): boolean => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    return regex.test(password);
};

interface Props {
  onClose: () => void;
}

const DialogNewPassword: React.FC<Props> = ({ onClose }) => {
    const dispatch: AppDispatch = useDispatch();
    const [newPassword, setNewPassword] = React.useState('');
    const [oldPassword, setOldPassword] = React.useState('');
    const [confirmNewPassword, setConfirmNewPassword] = React.useState('');

    const [showNewPassword, setShowNewPassword] = React.useState(false);
    const [showOldPassword, setShowOldPassword] = React.useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

    const [error, setError] = React.useState<string | null>(null);

    const isStrong = isStrongPassword(newPassword);
    const isMatch = newPassword === confirmNewPassword;
    const isValid = isStrong && isMatch;

    const handleSave = () => {
        if (!isValid) {
            setError('Password tidak valid atau tidak cocok.');
            return;
        }

        dispatch(action.showLoading());

        const payload = {
            body: {
                old_password: oldPassword,
                new_password: newPassword
            }
        };

        API.changePassword(payload)
            .then((response: any) => {
                dispatch(action.hideLoading());
                dispatch(action.showToast('success', response.message));
                onClose();
                dispatch(action.logout());
            })
            .catch((err: any) => {
                dispatch(action.hideLoading());
                dispatch(action.showToast('error', err.message));
                setError(err.message);
            });
    };

    return (
        <Dialog
            customWidth={700}
            dialogHandler={(visible) => !visible && onClose()}
        >
            <WrapperDialogNewPasswordWrapper>
                <div>
                    <h5
                        style={{ fontWeight: '700', textAlign: 'left', fontSize: '20px' }}
                    >
                        Ubah Kata Sandi
                    </h5>
                    <p style={{ fontSize: '15px', textAlign: 'left', fontWeight: '500' }}>
                        Untuk menjaga keamanan akun, silakan masukkan password lama Anda dan
                        buat password baru.
                    </p>
                </div>

                <WrapperTextInput>
                    <TextInputGroupStyled>
                        <p
                            style={{
                                fontWeight: '400',
                                padding: '0px',
                                margin: '0px',
                                marginBottom: '0px'
                            }}
                        >
                            Kata Sandi Lama
                        </p>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <TextInputStyled
                                type={showOldPassword ? 'text' : 'password'}
                                placeholder="Ketikan Kata Sandi Lama Anda"
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                            />
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    right: 10,
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer'
                                }}
                                onClick={() => setShowOldPassword(!showOldPassword)}
                            >
                                <Icon
                                    custom
                                    icon={showOldPassword ? iconEyeOpen : iconEyeClose}
                                />
                            </div>
                        </div>
                    </TextInputGroupStyled>

                    <TextInputGroupStyled>
                        <p
                            style={{
                                fontWeight: '400',
                                padding: '0px',
                                margin: '0px',
                                marginBottom: '0px'
                            }}
                        >
                            Kata Sandi Baru
                        </p>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <TextInputStyled
                                type={showNewPassword ? 'text' : 'password'}
                                placeholder="Ketikan Kata Sandi Baru Anda"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    right: 10,
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer'
                                }}
                                onClick={() => setShowNewPassword(!showNewPassword)}
                            >
                                <Icon
                                    custom
                                    icon={showNewPassword ? iconEyeOpen : iconEyeClose}
                                />
                            </div>
                        </div>
                        {!isStrong && newPassword.length > 0 && (
                            <ErrorMessage>
                                Kata sandi minimal 8 karakter, kombinasi huruf besar, kecil,
                                angka & simbol.
                            </ErrorMessage>
                        )}
                    </TextInputGroupStyled>

                    <TextInputGroupStyled>
                        <p
                            style={{
                                fontWeight: '400',
                                padding: '0px',
                                margin: '0px',
                                marginBottom: '0px'
                            }}
                        >
                            Konfirmasi Kata Sandi Baru
                        </p>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <TextInputStyled
                                type={showConfirmPassword ? 'text' : 'password'}
                                placeholder="Ketikan Kata Sandi Baru Anda"
                                value={confirmNewPassword}
                                onChange={(e) => setConfirmNewPassword(e.target.value)}
                            />
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    right: 10,
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer'
                                }}
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                                <Icon
                                    custom
                                    icon={showConfirmPassword ? iconEyeOpen : iconEyeClose}
                                />
                            </div>
                        </div>
                        {!isMatch && confirmNewPassword.length > 0 && (
                            <ErrorMessage>Konfirmasi kata sandi tidak cocok.</ErrorMessage>
                        )}
                    </TextInputGroupStyled>
                </WrapperTextInput>

                <WrapperDialogFooter>
                    <ButtonStyled onClick={handleSave} disabled={!isValid}>
                        Simpan
                    </ButtonStyled>
                </WrapperDialogFooter>
            </WrapperDialogNewPasswordWrapper>
        </Dialog>
    );
};

export default DialogNewPassword;
